export default __webpack_public_path__ + "static/webRotator/svg/a1ab980952ee327bb347bc01503851eb.svg";